// Engelse teksten van het woonkamerbord (zie kioskBoard.nl.ts).
export const kioskBoardEn = {
    weekToggle: 'Week',
    weekTitle: 'Week {week}',
    weekTitleToday: 'Today - Week {week}',
    backToToday: 'Today',
    menu: 'More',
    menuMake: 'Create',
    menuHome: 'Home',
    menuBoard: 'Board',
    boardRefreshing: 'Refreshing…',
    boardLoading: 'Loading…',
    boardRefreshFailed: 'Could not refresh: no connection. The board shows the last known data.',
    pageOf: 'Page {n} of {total}',
    prevWeek: 'Previous week',
    nextWeek: 'Next week',
    weekEmpty: 'This week is still empty',
    // Agendapagina van het bord (oprichter 1 okt 2026): Dag/Week, filter op personen.
    modeDay: 'Day',
    modeWeek: 'Week',
    agendaMode: 'View',
    prevDay: 'Previous day',
    nextDay: 'Next day',
    filterPeople: 'Show for',
    noEventsWeek: 'No events this week',
    noEventsDay: 'No events on this day',
    noEventsFor: 'Nothing planned for {names}',
    // Maandweergave van de agendapagina (oprichter 1 okt 2026).
    modeMonth: 'Month',
    prevMonth: 'Previous month',
    nextMonth: 'Next month',
    noEventsMonth: 'No events this month',
    // Reistijd-knop op de agendapagina (oprichter 1 okt 2026): ritten tonen of verbergen.
    travelToggle: 'Travel time',
    rideBring: 'Drop off',
    rideFetch: 'Pick up',
    rideOnTheWay: 'On the way',
    rideBack: 'Back',
    moreItems: '+{count}',
    laterAt: 'Later · {time}',
    nowUntil: 'Now · until {time}',
    tasksMore: 'More tasks',
    tasksLess: 'Back to top',
    scrollMore: 'More appointments',
    departWho: '{names}: leave at {time} for {title}',
    // Rijders op de detailkaart (oprichter 1 okt: alles vertaald).
    rideDropoff: '{name} drops off',
    ridePickup: '{name} picks up',
    and: 'and',
    departClose: 'Close notice',
    travel: '{minutes} min on the road',
    leaveAt: 'leave at {time}',
    /** 0056: reistijd terug: thuis rond deze tijd. */
    travelBack: 'home at {time}',
    conflict: 'At the same time as something else',
    continues: 'Continues',
    tomorrowFirst: 'Tomorrow {time}: {title}',
    waitingApproval: 'Waiting for mum/dad',
    klaarApproval: 'Mum or dad will still check it.',
    doneBy: '{name} was first',
    claimedBy: '{name} is doing this',
    tryAgain: 'One more time?',
    notSaved: 'That did not work',
    cloudPending: 'Saving…',
    memberRail: 'Family members',
    pointsReserved: '{count} reserved',
    rewardsTile: 'Rewards',
    rewardsOf: 'Rewards for {name}',
    goal: 'Goal: {name}',
    goalHint: 'Pick a savings goal together',
    goalProgress: '{value} of {max}',
    rewardCanGet: 'You can!',
    /** Rustig, buiten het thema Kinderen. */
    rewardCanGetCalm: 'Available',
    rewardMissing: '{count} to go',
    rewardWaiting: 'Waiting for mum/dad',
    rewardBusy: 'The other one first',
    rewardLimit: 'Again tomorrow',
    rewardSoldOut: 'Sold out',
    rewardCancel: 'Cancel',
    whoAreYou: 'Who are you?',
    requestQuestion: 'Ask for {reward}?',
    cancelQuestion: 'Not {reward} after all?',
    keepIt: 'No, keep it',
    cancelYes: 'Yes, not after all',
    notYou: 'Not you?',
    areYou: 'Are you {name}?',
    yesMe: 'Yes, that is me',
    notMe: 'No',
    notYours: 'This belongs to {name}',
    notYoursBody: 'Look, here is your list.',
    closeRewards: 'Back to today',
    detailClose: 'Close',
    detailEdit: 'Edit',
    sleepWell: 'Sleep well',
    tomorrowAt: 'Tomorrow at {time}: {title}',
    calmDown: 'Take it easy…',
    upcoming: 'Coming up',
    tomorrowEmpty: 'Nothing planned yet',
    inDays: { one: 'in {count} day', other: 'in {count} days' },
};
//# sourceMappingURL=kioskBoard.en.js.map